import { EdgeItemType } from 'data/types';

function getSolidDoorLabel(item: EdgeItemType): string {
  const width = item.width ?? 0;
  if (width >= 12) return 'Double Garage Door';
  if (width >= 8) return 'Single Garage Door';
  if (width > 0 && width <= 2) return 'Pet Door';
  if (item.material === 'Metal') return 'Metal Door';
  if (item.material === 'Wood') return 'Wood Door';
  return 'Door';
}

export function getEdgeItemLabel(item: EdgeItemType): string {
  if (item.type === 'window') return 'Window';
  if (item.type === 'glass-door') return 'Glass Door';
  return getSolidDoorLabel(item);
}

export function getEdgeItemTooltip(item: EdgeItemType): string {
  const label = getEdgeItemLabel(item);
  if (item.width && item.height) {
    return `${label}: ${item.width}ft x ${item.height}ft`;
  }
  return label;
}
